<template>
	<button @click="clearToast">{{ buttonText }}</button>
</template>

<script>
import i18n from "@/plugins/i18n/translations";
export default {
	data() {
		return {
			buttonText: i18n.t("messages.okUnderstand")
		};
	},
	methods: {
		clearToast() {
			this.$toast.clear();
		}
	}
};
</script>
